import i18n from '@/locales/i18n';

/**
 *  MAPA DE TRADUCCIONES
 *  Parámetros de configuración
 */

const mapTranslations = {
  RS485_AVAILABLEMODES: {
    0: () => i18n.t('protocol.modbus'),
    1: () => i18n.t('protocol.bacnet'),
    2: () => i18n.t('protocol.airQBox'),
    3: () => i18n.t('protocol.paladiom'),
    4: () => i18n.t('protocol.meters'),
    5: () => i18n.t('protocol.airzoneThermostat'),
  },
};

export default mapTranslations;
